<template>
  <div>

    <div class="month-selector" @click="toggleCalendar">
      <i class="fa fa-calendar"></i>
      <span>{{ dater.activeMonthStr }}</span>
    </div>

    <div class="datepicker" v-show="isCalendarVisible">
      <Datepicker @input="changedDate" v-model="dateValue" ref="programaticOpen" :inline="true" :minimum-view="'month'"
        :maximum-view="'month'" :initial-view="'month'" :disabled-dates="disabledDates" />
    </div>
  </div>
</template>

<script>
import Dater from '@/repositories/dater'
import Datepicker from 'vuejs3-datepicker';


export default {
  components: {
    Datepicker
  },
  props: {
    minimumDate: {
      type: Date,
      default: () => new Date(2025, 5, 1),
    },
  },
  data() {
    return {
      dater: Dater,
      dateValue: '',
      isCalendarVisible: false,
      disabledDates: {},
    }
  },
  created() {
    this.$store.dispatch('datesModule/setActiveDates', this.dater.getFormattedArray());
  },
  mounted() {
    this.disableDates();
  },
  methods: {
    toggleCalendar() {
      this.$refs.programaticOpen.showCalendar()
      this.isCalendarVisible = !this.isCalendarVisible;
    },
    changedDate(dateValue) {
      this.$store
        .dispatch('authentication/validateActiveSession')
        .then(() => {
          this.isCalendarVisible = false
          this.dater.getDate(dateValue)
          this.$store.dispatch('datesModule/setActiveDates', this.dater.getFormattedArray());
        })
        .catch(() => {
          this.$router.push({ name: 'home' })
        })

    },
    disableDates() {
      const dates = this.dater.disabledDatesInDatepicker()
      dates.to = this.minimumDate
      this.disabledDates = dates
    }
  },
}
</script>


